import React from "react";
import MusicPlayer from "../components/musicPlayer";

const MusicPlayerPage = () => {
  return (
    <>
      <MusicPlayer />
    </>
  );
};

export default MusicPlayerPage;
